import { Text, View } from "react-native";
import TableList from "../../../components/organisms/TableList";
import { ColumnModel } from "../../../services/api/types/common/models/ColumnModel";
import StatusIndicator from "ui/atoms/avatar/statusIndicator/StatusIndicator";
import { StatusIndicatorMapping } from "../../../services/api/types/offline/enums/SyncingRequestStatusEnum";
import { OfflineRequestStatusModel } from "../../../services/api/types/offline/models/OfflineRequestStatusModel";
import { format } from "date-fns";

export interface Props {
  data?: OfflineRequestStatusModel[];
  isLoading?: boolean;
}

export function SyncProgressTable({ data, isLoading }: Props) {
  const columns: ColumnModel<OfflineRequestStatusModel>[] = [
    {
      title: "Action",
      dataKey: "description",
      renderCell: (item: OfflineRequestStatusModel) => (
        <View>
          <Text className="text-base text-typography-900">
            {item.description}
          </Text>
        </View>
      ),
    },
    {
      title: "Date and Time",
      dataKey: "user",
      renderCell: (item: OfflineRequestStatusModel) => (
        <View>
          <Text className="text-base text-typography-900">
            {format(new Date(item.creation_date), "dd-MM-yyyy HH:mm")}
          </Text>
        </View>
      ),
    },
    {
      title: "Submitted By",
      dataKey: "user",
      renderCell: (item: OfflineRequestStatusModel) => (
        <View>
          <Text className="text-base text-typography-900">
            {item.user.first_name} {item.user.last_name}
          </Text>
        </View>
      ),
    },
    {
      title: "Status",
      dataKey: "status",
      renderCell: (item: OfflineRequestStatusModel) => (
        <View>
          <StatusIndicator
            status={StatusIndicatorMapping[item.status]}
            statusTitle={item.status}
          />
        </View>
      ),
    },
  ];

  return (
    <View>
      <TableList
        columns={columns}
        data={data}
        showHorizontalRowDivider
        showHorizontalHeaderDivider
        isFetching={isLoading}
      />
    </View>
  );
}
